import { SocketProvider } from './../../providers/socket/socket';
import { Component, OnInit, OnDestroy, AfterContentInit } from '@angular/core';
import { IonicPage, NavController, NavParams, AlertController } from 'ionic-angular';
import { Subscription } from 'rxjs';

/**
 * Generated class for the ControlsGeyserPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-controls-geyser',
  templateUrl: 'controls-geyser.html'
})
export class ControlsGeyserPage implements OnDestroy {
  commandRunning: boolean = false;
  commandResults: any = {};
  client: any;
  shadow: any;
  serial: string;

  socketReady: boolean = false;
  socketStatusText: string = 'Connecting to device';

  client$: Subscription;
  device$: Subscription;
  shadow$: Subscription;
  account$: Subscription;

  deviceView: any;
  accountView: any;
  shadowView: any;
  device: any;

  timerDuration: number = 0;
  timerPercentage: number = 0;
  timerStartTime: Date = new Date();
  timerTestTitle: string = '';
  timerTitle: string = '';
  timerRunning: boolean = false;

  constructor(
    public navCtrl: NavController,
    public navParams: NavParams,
    private sniotService: SocketProvider,
    private alertCtrl: AlertController
  ) {}

  ionViewDidLoad() {
    this.serial = this.navParams.get('serial');
    this.initSocket();
  }

  ngOnDestroy() {
    if (this.client$) this.client$.unsubscribe();
    if (this.device$) this.device$.unsubscribe();
    if (this.shadow$) this.shadow$.unsubscribe();
  }

  initSocket() {
    this.client$ = this.sniotService.getClient().subscribe(client => {
      this.client = client;

      if (this.client) {
        this.device$ = this.sniotService
          .bindCollection(client.deviceShadow.getDeviceCollection(), {
            profile: { $in: ['snn:device-profile:geyser:v1', 'snn:device-profile:geyser:v2'] },
            serial: this.serial
          })
          .subscribe(view => {
            this.deviceView = view;
            this.device = view.data.toArray()[0];
            this.checkSocketStatus();
          });

        this.shadow$ = this.sniotService
          .bindCollection(client.deviceShadow.getShadowCollection(), {
            profile: { $in: ['snn:device-profile:geyser:v1', 'snn:device-profile:geyser:v2'] },
            serial: this.serial
          })
          .subscribe(view => {
            this.shadowView = view;
            this.shadow = view.data.toArray()[0];
            this.checkSocketStatus();
          });
      }
    });
  }

  initDevice() {}

  checkSocketStatus() {
    // if (this.device && this.shadow) {
    if (this.shadow) {
      this.socketReady = true;
      this.socketStatusText = 'Connected';
    }
  }

  forceRelayOn() {
    const reported = this.shadow.state.reported;

    if (reported.faultElementOpen || reported.faultElementDrawingCurrent) {
      let faults = '<br /><br />Faults:';
      if (reported.faultElementDrawingCurrent) faults = faults + '<br />Element not drawing current.';
      if (reported.faultElementOpen) faults = faults + '<br />Element is open.';

      let alert = this.alertCtrl.create({
        title: 'Element Fault',
        message: 'Cannot run test while element has faults.' + faults,
        buttons: ['OK']
      });
      alert.present();
    } else {
      let seconds: any = 10; // 5 seconds

      if (!seconds || !parseInt(seconds, 10)) {
        return;
      }
      seconds = parseInt(seconds, 10);
      if (seconds < 0 || seconds > 300) {
        return;
      }

      // TODO: add check that valve is open when element is tested
      console.log('FLAG WATERVALVE OPEN: ', this.shadow.state.reported.flagWaterValveOpen);
      if (this.shadow && this.shadow.state && this.shadow.state.reported && this.shadow.state.reported.flagWaterValveOpen) {
        this.timerTestTitle = 'Element Test';
        this.initTimer(seconds, 'Element Test', 'geyser:forceRelayOn');
        this.runCommand('geyser:forceRelayOn', { seconds: seconds });
      } else {
        let alert = this.alertCtrl.create({
          title: 'Valve is closed',
          message: 'Valve must be open before testing the element.',
          buttons: ['OK']
        });
        alert.present();
      }
    }
  }

  forceValveOpen() {
    if (this.shadow.state.reported.flagWaterValveOpen) {
      let alert = this.alertCtrl.create({
        title: 'Error!',
        message: 'Cannot run Pressure Test while valve is open.',
        buttons: [
          {
            text: 'OK',
            role: 'ok',
            handler: data => {}
          }
        ]
      });
      alert.present();
    } else {
      let minutes: any = 1; // 1 minutes
      if (!minutes || !parseInt(minutes, 10)) {
        return;
      }
      minutes = parseInt(minutes, 10);
      if (minutes < 0 || minutes > 720) {
        return;
      }
      this.initTimer(minutes * 60, 'Pressure Test', 'geyser:forceValveOpen');
      this.runCommand('geyser:forceValveOpen', { minutes: minutes });
    }
  }

  initTimer(secs: number, title: string, command: string) {
    // this.startTimer(secs);
    this.timerDuration = 0;
    this.timerPercentage = 0;
    this.timerRunning = true;
    this.commandResults[command] === 'starting';
    let timeout = 0;
    const int = setInterval(() => {
      this.timerTitle = title + ': ' + this.commandResults[command].charAt(0).toUpperCase() + this.commandResults[command].slice(1);

      if (this.commandResults[command] === 'running') {
        if (this.timerDuration === 0) {
          this.timerDuration = secs * 1000;
          this.timerStartTime = new Date();
        } else {
          this.timerTitle = title + ': ' + this.commandResults[command].charAt(0).toUpperCase() + this.commandResults[command].slice(1);
          const now = new Date().getTime();
          const currentValue = now - this.timerStartTime.getTime();
          this.timerPercentage = (currentValue / this.timerDuration) * 100;
          if (this.timerPercentage >= 100 && this.timerDuration) {
            this.timerTitle = title + ': ' + 'Done';
            this.timerPercentage = 100;
            this.timerRunning = false;
            clearInterval(int);
          }
        }
      } else {
        timeout++;
        if (timeout > 600) {
          this.timerTitle = title + ': ' + 'Timeout';
          this.timerPercentage = 100;
          this.timerRunning = false;
          clearInterval(int);
        }
      }
    }, 100);
  }
  // startTimer(secs: number) {

  // }

  getPercentage() {
    return 0;
  }

  runCommand(command, params?) {
    const self = this;
    if (this.commandRunning) {
      return;
    }
    this.commandRunning = true;
    this.commandResults[command] = 'starting';
    this.client.deviceShadow
      .executeDeviceShadowCommand({
        snn: this.shadow.snn,
        command: command,
        params: params
      })
      .then(function(result) {
        console.log('result.result',result.result);
        self.commandRunning = false;
        if (result.errorCode) {
          self.commandResults[command] = '' + result.result + ' [' + result.errorCode + ']';
        } else {
          self.commandResults[command] = result.result === 'ack' ? 'running' : result;
        }
      });
  }

  commandStatus(command: string) {
    return this.commandResults[command] ? this.commandResults[command] : 'none';
  }
}



// WEBPACK FOOTER //
// ./src/pages/controls-geyser/controls-geyser.ts